import { lang } from 'enablex/shared'
import React, { FC, useState } from 'react'
import { RouteComponentProps } from 'react-router'

import { ExtendedHistory } from '~/app/history'
import BasicAuthentication, { getCurrentRole } from '~/auth/basicAuth'

import LoginContainer from './LoginContainer'

type RouterProps = RouteComponentProps<  {  token: string; workspace: string; expiry: string }>

type Props = { auth: BasicAuthentication } & RouterProps & ExtendedHistory



const AutoLogin: FC<Props> = props => {
  const [error, setError] = useState<string | null>()


  const initialize = async () => {
    const token_jwt = props.match.params.token
    const token_expiry = parseInt(props.match.params.expiry)
    const workspaceId = props.match.params.workspace
    const payload = {
      jwt: token_jwt,
      exp: token_expiry
    }

    // Determine redirect URL based on user role
    const currentUserRole = getCurrentRole()
    const baseUrl = currentUserRole === 'supervisor' ? 'admin/workspace/default/dashboard' : 'admin/workspace/default/bots'

    try {
      await props.auth.autoLogin(payload, baseUrl, workspaceId)
    } catch (error) {
      setError(error.message)
    }
  }

    // Call initialize when the component is rendered
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    initialize()

  return (
    <LoginContainer title={lang.tr('admin.login')} error={error} poweredBy={true}>
        <p>Loading...</p>
    </LoginContainer>
  )
}

export default AutoLogin
